var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0001 3.42432C10.2601 3.42432 3.16675 10.5176 3.16675 19.2576C3.16675 27.9976 10.2601 35.091 19.0001 35.091C27.7401 35.091 34.8334 27.9976 34.8334 19.2576C34.8334 10.5176 27.7401 3.42432 19.0001 3.42432ZM19.0001 31.9243C12.0176 31.9243 6.33341 26.2401 6.33341 19.2576C6.33341 12.2751 12.0176 6.59098 19.0001 6.59098C25.9826 6.59098 31.6667 12.2751 31.6667 19.2576C31.6667 26.2401 25.9826 31.9243 19.0001 31.9243ZM15.0417 26.3826L26.1251 19.2576L15.0417 12.1326V26.3826Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "static/media/play_circle.a9a63955d39f1b6b71e4b1046a0701dc.svg";
export { ForwardRef as ReactComponent };